export default function ErrorMessage({ error }) {
  if (!error) {
    return null;
  }
  return <p className="text-red-600">{error.message || error}</p>;
}
